import { GDPRContext, GDPRConsumer, GDPRProvider } from './gdpr-context';

export { GDPRContext, GDPRConsumer, GDPRProvider };

export default GDPRContext;
